import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { MODULES } from '../data/modules';
import { scrollToBuy } from '../utils/constants';
export function Modules() {
  return <section aria-labelledby="modules-title" className="w-full bg-night px-4 py-8" data-id="element-133" data-mp="1vwsjckwqbbkc">
      <div className="mx-auto max-w-6xl" data-id="element-134" data-mp="20woo4md9370y">
        <div className="text-center" data-id="element-135" data-mp="20vnduk426oka">
          <span className="font-head text-[10px] font-semibold uppercase tracking-[0.14em] text-cta sm:text-xs" data-id="element-136" data-mp="145w8fpu8bgzp">
            The complete professional collection
          </span>
          <h2 id="modules-title" className="mt-1 font-head text-xl font-bold uppercase leading-[0.98] text-white sm:text-3xl" data-id="element-137" data-mp="189kg08iv2cky">
            Inside the system — six complete professional modules
          </h2>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-138" data-mp="2olzssexq1lkd">
          {MODULES.map(mod => {
          const Icon = mod.icon;
          return <button key={mod.number} type="button" onClick={scrollToBuy} aria-label={`Go to the purchase section — ${mod.title}`} className="flex flex-col overflow-hidden rounded-xl border border-white/10 bg-panel text-left transition-colors duration-150 ease-out hover:border-cta/50" data-id="element-139" data-mp="2tjj3j4v7ng7k">
                <span className={`h-1 w-full ${mod.accent}`} aria-hidden="true" data-id="element-140" data-mp="3oypw5rseuo71" />
                <span className="flex flex-1 flex-col p-3" data-id="element-141" data-mp="3k17lnwyqw0wx">
                  <span className="flex items-center gap-2" data-id="element-142" data-mp="3k32494mjngxu">
                    <span className={`flex h-7 w-7 items-center justify-center rounded-md text-white ${mod.accent}`} data-id="element-143" data-mp="3f2ee0l65344o">
                      <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-144" data-mp="3a9lce65ywbwt" />
                    </span>
                    <span className="font-head text-[10px] font-semibold uppercase tracking-widest text-silver/70" data-id="element-145" data-mp="369j5nildksao">
                      Module {mod.number}
                    </span>
                  </span>
                  <span className="mt-1.5 block font-head text-base font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-146" data-mp="2wd7ren285sdl">
                    {mod.title}
                  </span>
                  <span className="mt-1 block text-[12px] font-semibold leading-snug text-cta" data-id="element-147" data-mp="2hmtpk2kn2d3s">
                    {mod.hook}
                  </span>
                  <span className="mt-1 block text-[12px] leading-snug text-silver" data-id="element-148" data-mp="28o886aqwl44l">{mod.body}</span>
                  <span className="mt-auto block pt-2 text-[9px] font-semibold uppercase leading-snug tracking-wide text-silver/60" data-id="element-149" data-mp="2cos2z7o07vnk">
                    {mod.tags}
                  </span>
                </span>
              </button>;
        })}
        </div>

        <div className="mt-4 flex flex-col items-center" data-id="element-150" data-mp="35g3fjhf2n0mt">
          <CtaButton data-id="element-151" data-mp="2rlj69s0strig" />
          <TrustRow className="mt-1.5" data-id="element-152" data-mp="2rm2nt7mjedvy" />
        </div>
      </div>
    </section>;
}